// Update-period quick options for a new meeting (spec §3.1). Dates are "YYYY-MM-DD" strings;
// math is done in UTC so a user's timezone never shifts a day.
export const PERIOD_OPTIONS = [
  { value: "since_last", label: "Since last update meeting" },
  { value: "last_2_weeks", label: "Last 2 weeks" },
  { value: "custom", label: "Custom dates" },
];
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const valid = (d) => typeof d === "string" && DATE_RE.test(d);

// Today's date as "YYYY-MM-DD" in the user's own timezone (toISOString would give UTC, which is
// already tomorrow on a US evening).
export function localToday(now = new Date()) {
  return localDate(now);
}
export function localDate(d) {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function addDays(dateStr, n) {
  const d = new Date(`${dateStr}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

export function lastMeetingDate(meetings, beforeDate) {
  const held = (meetings || [])
    .filter((m) => (m.status === "presented" || m.status === "sent") && valid(m.meetingDate) && m.meetingDate < beforeDate)
    .map((m) => m.meetingDate)
    .sort();
  return held.length ? held[held.length - 1] : null;
}

export function computePeriod(option, { meetingDate, meetings = [], customStart, customEnd } = {}) {
  if (option === "custom") {
    if (!valid(customStart) || !valid(customEnd)) return { ok: false, error: "Pick both a start and an end date." };
    if (customStart > customEnd) return { ok: false, error: "The start date must be on or before the end date." };
    return { ok: true, start: customStart, end: customEnd, fellBack: false };
  }
  if (!valid(meetingDate)) return { ok: false, error: "Pick the meeting date first." };
  if (option === "since_last") {
    const last = lastMeetingDate(meetings, meetingDate);
    if (last) return { ok: true, start: last, end: meetingDate, fellBack: false };
    return { ok: true, start: addDays(meetingDate, -14), end: meetingDate, fellBack: true };
  }
  return { ok: true, start: addDays(meetingDate, -14), end: meetingDate, fellBack: false };
}
